/**
 * Transports SockJS selon l'hébergement (UAT 07.09, Olivier 1.8).
 *
 * Derrière Azure Static Web Apps, le lien « backend » relaie /api/* mais pas
 * l'upgrade WebSocket : le transport `websocket` échoue systématiquement et
 * laisse une erreur rouge dans la console (« WebSocket connection to
 * wss://dev.uptk.cloud/api/ws/… failed ») avant que SockJS ne retombe sur
 * eventsource / xhr, qui fonctionnent. Quand l'app est servie par SWA (pas de
 * VITE_API_URL, hôte distant), on n'essaie donc pas le WebSocket. En local
 * (backend direct sur :8080) le WebSocket natif reste le premier choix.
 * Les transports iframe restent exclus (UPT-1615, prompt de téléchargement iOS).
 */
const DIRECT_TRANSPORTS = ['websocket', 'eventsource', 'xhr-streaming', 'xhr-polling'];
const PROXIED_TRANSPORTS = ['eventsource', 'xhr-streaming', 'xhr-polling'];

export function sockJsTransports(): string[] {
  const apiUrl = typeof import.meta !== 'undefined' ? (import.meta.env?.VITE_API_URL as string | undefined) : undefined;
  if (apiUrl && apiUrl.trim() !== '') return DIRECT_TRANSPORTS;
  if (typeof window === 'undefined') return PROXIED_TRANSPORTS;
  const host = window.location.hostname;
  const isLocal = host === 'localhost' || host === '127.0.0.1' || host.endsWith('.localhost');
  return isLocal ? DIRECT_TRANSPORTS : PROXIED_TRANSPORTS;
}
